// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ContainerOutlinedSvg from "@ant-design/icons-svg/es/asn/ContainerOutlined";
import AntdIcon from '../components/AntdIcon';

var ContainerOutlined = function ContainerOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: ContainerOutlinedSvg
  }));
};

ContainerOutlined.displayName = 'ContainerOutlined';
export default React.forwardRef(ContainerOutlined);